import { ReconBankProcessPage } from "@/features/recon-bank/pages/ReconBankProcessPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank/$id/process")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconBankProcessPage,
});
